import { getSession } from "./localStorage";

const hasLoggedInCustomer = (session) => {
  if (!session || typeof session !== "object") return false;

  const customer = session?.customer;
  if (!customer) return false;
  if (typeof customer !== "object" || Object.keys(customer).length === 0) return false;

  // Explicit guest marker from backend should never be treated as logged in.
  if (customer.asGuest === true) return false;

  // Logged sessions include a purchaser id and/or a persisted customer id.
  const hasPurchaser = session.purchaser !== null && session.purchaser !== undefined && session.purchaser !== "";
  const hasCustomerId = customer.id !== null && customer.id !== undefined && customer.id !== "";

  return hasPurchaser || hasCustomerId;
};

const isUserLogedIn = () => {
  return hasLoggedInCustomer(getSession());
};

export { hasLoggedInCustomer, isUserLogedIn };
